import type { AttachmentDto } from '@lex/contracts';
import type { ApiClient } from './client';

export function createMediaApi(client: ApiClient) {
  return {
    createUpload(body: {
      conversationId?: string;
      name: string;
      mimeType: string;
      size: number;
    }): Promise<AttachmentDto & { uploadUrl: string }> {
      return client.post('/api/v1/media/uploads', body);
    },
    complete(id: string): Promise<AttachmentDto> {
      return client.post(`/api/v1/media/uploads/${id}/complete`, {});
    },
    url(id: string): Promise<{ url: string }> {
      return client.get(`/api/v1/media/attachments/${id}/url`);
    },
    async uploadFile(
      file: File,
      conversationId?: string
    ): Promise<AttachmentDto> {
      const created = await this.createUpload({
        ...(conversationId ? { conversationId } : {}),
        name: file.name,
        mimeType: file.type || 'application/octet-stream',
        size: file.size,
      });
      const response = await fetch(created.uploadUrl, {
        method: 'PUT',
        headers: { 'content-type': file.type || 'application/octet-stream' },
        body: file,
      });
      if (!response.ok) throw new Error(`upload: HTTP ${response.status}`);
      return this.complete(created.id);
    },
  };
}
